import {
  deleteFavicon,
  deleteIcon,
  deleteLogo,
  // deleteStartPagePicture,
  FAVICON,
  ICON,
  LOGO,
  setLocalImageSrc,
  // START_PAGE_PICTURE,
} from "../../constants/localStorageKeys";

export const setLogos = (
  logo: File,
  icon: File,
  favicon: File,
  startPagePicture: File
) => {
  if (logo?.size) {
    setLocalImageSrc(logo, LOGO);
  } else {
    deleteLogo();
  }
  if (icon?.size) {
    setLocalImageSrc(icon, ICON);
  } else {
    deleteIcon();
  }
  if (favicon?.size) {
    setLocalImageSrc(favicon, FAVICON);
  } else {
    deleteFavicon();
  }
  // if (startPagePicture?.size) {
  //   setLocalImageSrc(startPagePicture, START_PAGE_PICTURE);
  // } else {
  //   deleteStartPagePicture();
  // }
};
